module.exports = __webpack_public_path__ + "static/media/029.7272a08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/029.jpg
// module id = 536
// module chunks = 0